export default __webpack_public_path__ + "static/media/twitter.2b4c2d18.svg";